import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/inspirational/base"

const inspirational = {
  inspirationalPageList(pageSize, limit, keyWord, type) {
    return axios.get(pre + `/inspirationalPageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          type: type
        }
    });
  },

  musicPageList(pageSize, limit, keyWord) {
    return axios.get(pre + `/musicPageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord
        }
    });
  },
  inspirationalInfo(id) {
    return axios.get(pre + `/inspirationalInfo`, {params: {id: id}});
  },
  inspirationalSave(params) {
    return axios.post(pre + `/inspirationalSave`, qs.stringify(params));
  },
  inspirationalDelete(id) {
    return axios.delete(pre + `/inspirationalDelete`, {params: {id: id}});
  },
  uploadZip(formData) {
    return axios.post(pre +'/uploadZip', formData, {
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      }
    });
  }
}
export default inspirational;



// WEBPACK FOOTER //
// ./src/api/inspirational/inspirational.js